import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App.tsx';
import { IS_PROD, config } from './common/config.ts';
import './index.css';

document.title = config.COMPANY_NAME;

IS_PROD &&
  Sentry.init({
    dsn: 'https://484056de44cf0d449a267292c4d2a23a@sentry.techpay.dev/8',
    integrations: [
      Sentry.browserApiErrorsIntegration(),
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      Sentry.reactErrorHandler(),
      Sentry.reactRouterV6BrowserTracingIntegration({} as any),
    ],
    beforeSend(event) {
      // Добавление тегов
      event.tags = {
        ...event.tags,
        'lk-type': import.meta.env.VITE_COMPANY_NAME,
      };
      return event;
    },
    environment: 'production',
    normalizeDepth: 10,
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
